function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h2',[_vm._v("Let's meet online")]),_vm._v(" "),_c('p',[_vm._v("See call tracking in action by calling trough our contact center. This call is just for for the demo don't expect someone to pick the phone on the other side. After you hear the wellcome message you can recoder a small message to see it being transcribed in real time.")])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/interactions/meetings/details","date":"Meeting date","name":"Name","meeting":"Where do you want to meet us?","request":"Request","subject":"WhiteBox Meeting Request - {{rid}}"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }